module.exports = require("redux");


/*****************
 ** WEBPACK FOOTER
 ** external "redux"
 ** module id = 37
 ** module chunks = 0
 **/